<template>
  <tbody class="is-editable">
    <tr>
      <!-- <td class="c-table__cell--center c-table__cell--middle u-w100">{{ message.message_group_message ? message.message_group_message.message_group.group_name : '-' }}</td> -->
      <td class="c-table__cell--middle">
        <p class="u-w200 u-text-ellipsis">
          {{ customParameterType }}
        </p>
      </td>
      <td class="c-table__cell--middle">
        <p class="u-w500 u-text-ellipsis">
          {{ customParameter.parameter_value }}
        </p>
      </td>
      <td class="c-table__cell--middle">
        <p class="u-w160 u-text-ellipsis">
          {{ customParameter.create_date }}
        </p>
        <div class="c-table-editable">
          <ul class="c-table-editable-list">
            <li class="c-table-editable-list__item">
              <a class="c-btn c-btn--white c-btn--circle" href="#edit" @click="onEditClick">
                <div class="c-btn__text c-btn__text--balloon">編集する</div>
                <div class="c-icon c-icon--gray-3 u-wh20">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <use xlink:href="/assets/img/sprite.svg#edit" />
                  </svg>
                </div>
              </a>
            </li>
            <li class="c-table-editable-list__item">
              <a class="c-btn c-btn--white c-btn--circle" href="#trash" @click="onDeleteClick">
                <div class="c-btn__text c-btn__text--balloon">削除する</div>
                <div class="c-icon c-icon--gray-3 u-wh20">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <use xlink:href="/assets/img/sprite.svg#trash" />
                  </svg>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
export default {
  props: {
    customParameter: Object,
  },
  emits: ["delete-click","edit-click"],
  data: function () {
    return {
      customParameterTypes: {
        1: 'UTMパラメーター',
      }
    };
  },
  computed: {
    customParameterType: function () {
      return this.customParameterTypes[this.customParameter.parameter_type];
    },
  },
  methods: {
    onDeleteClick: function () {
      this.$emit('delete-click', this.customParameter);
    },
    onEditClick: function () {
      this.$emit('edit-click', this.customParameter);
    },
  },
};
</script>